import { mutatorAction } from 'satcheljs';
import { getRecentFilesStore } from '../store/RecentFilesStore';
import { FileListLoadingStatus } from '../Schema/FileListLoadingStatus';
import { getRecentFilesList } from '../selectors/getRecentFilesList';

const updateRecentFilesLoadingAndErrorStatus = mutatorAction(
    'updateRecentFilesLoadingStatus',
    function updateRecentFilesLoadingAndErrorStatus(
        groupSmtp: string,
        fileListLoadingStatus: FileListLoadingStatus,
        fileListErrorStatus: string,
        cache: boolean
    ) {
        groupSmtp = groupSmtp.toLowerCase();
        const recentFilesStore = getRecentFilesStore();

        // Get the recent files list for the group, or a list with default values if group not found
        const currentRecentFilesList = getRecentFilesList(groupSmtp);

        if (cache) {
            // Update the loading status in the list
            currentRecentFilesList.fileListCacheLoadingStatus = fileListLoadingStatus;

            // Update the error status in the list
            currentRecentFilesList.fileListCacheErrorStatus = fileListErrorStatus;
        } else {
            // Update the loading status in the list
            currentRecentFilesList.fileListRefreshLoadingStatus = fileListLoadingStatus;

            // Update the error status in the list
            currentRecentFilesList.fileListRefreshErrorStatus = fileListErrorStatus;
        }

        // Update the loading status if group found in map, or add new entry to the recent files list map
        recentFilesStore.recentFilesPerGroup.set(groupSmtp, currentRecentFilesList);
    }
);

export default updateRecentFilesLoadingAndErrorStatus;
